import { z } from 'zod';
import { surrogateKeySchema } from './primitives.js';
/**
 * 患者表示情報。AWS側の永続層・ログ・バックアップへ保存しない（要件 4-4 / #5）。
 * APIレスポンスとブラウザのメモリ上だけで扱う。
 */
export const patientDisplaySchema = z.object({
    patientId: z.string().min(1).max(32),
    name: z.string().min(1).max(64),
    dept: z.string().max(64),
    age: z.number().int().min(0).max(120).nullable(),
    sex: z.string().max(8),
    birth: z.string().max(16),
});
/**
 * 院内から取得する当日の対象患者。表示情報と、永続化してよい非個人項目を分けて持つ。
 * rpCount / departmentCode の保存可否はデータ分類表の確定後に永続スキーマへ入れる。
 */
export const todayPatientSchema = z.object({
    surrogateKey: surrogateKeySchema,
    rpCount: z.number().int().min(1).max(9),
    display: patientDisplaySchema,
});
//# sourceMappingURL=patient.js.map